module.exports = __webpack_public_path__ + "media/images/partners/mcdoc-7d07e608e0bab138e2016d6bff038f45.png";